// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Grid from "@mui/material/Grid2";
import {
  Box,
  CircularProgress,
  IconButton,
  styled,
  Switch,
  TextField,
  useMediaQuery
} from "@mui/material";
import { LiveIcon, CashIcon, NoBuyerIcon, ReportedIcon } from "../../components/Live";
import HotelIcon from "@mui/icons-material/LocalHotelOutlined";
import CottageOutlinedIcon from "@mui/icons-material/CottageOutlined";
import BathtubOutlinedIcon from "@mui/icons-material/BathtubOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { useNavigate, useOutletContext } from "react-router-dom";
import moment from "moment";
import Loading from "../../components/Loading";
import { useDispatch, useSelector } from "react-redux";
import { fetchPropertiesByPageNumber } from "../../redux/slice/propertiesSlice";
import PropertiesFilterHeader from "../../components/commonComponents/PropertiesFilterHeader";
import filterIcon from "../../assets/filterIcon.svg";
import Bed from "../../assets/bed.svg";
import Bath from "../../assets/bath.svg";
import Sqft from "../../assets/sqft.svg";

// import PropertiesFilterHeader from "./PropertiesFilterHeader";
import {
  addFavoriteProperty,
  getFavorityProperty,
  addSelectedId,
  removeSelectedId,
} from "../../redux/slice/favoritePropertySlice";
import ProductDetailsPage from "../../components/auctionPage/ProductDetailsPage";
import { BackButton } from "../../components/commonComponents/BackButton";
function List() {
  const isMdOrLarger = useMediaQuery("(min-width:1000px)");
  const scrollContainerRef = useRef(null);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedCounties, setSelectedCounties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isRemoteBiddingEnable, setIsRemoteBiddingEnable] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedAuctionStatus, setSelectedAuctionStatus] = useState([]);
  const [selectedPropertyType, setSelectedPropertyType] = useState([]);

  const [filteredAuctions, setFilteredAuctions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [priceRange, setPriceRange] = useState({ min: null, max: null });
  const [beds, setBeds] = useState("Any");
  const [baths, setBaths] = useState("Any");
  const [lotSize, setLotSize] = useState({
    min: "No Minimum",
    max: "No Maximum",
  });
  const [squareFootage, setSquareFootage] = useState({ min: null, max: null });
  const [yearBuilt, setYearBuilt] = useState({ min: null, max: null });
  // Separate states for Occupancy
  const [generalOccupancy, setGeneralOccupancy] = useState([]);
  const [reportedVacancy, setReportedVacancy] = useState(false);
  const [isDataAvailable, setIsDataAvailable] = useState(true);
  const [propertySortBy, setPropertySortBy] = useState("")
  const isMobile = useOutletContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { properties } = useSelector((state) => state.properties);
  const { investorId } = useSelector((state) => state?.user);
  const { favoriteProperties } = useSelector(
    (state) => state.favoriteProperties
  );
  const selectedIndex = useSelector(
    (state) => state.favoriteProperties.selectedIds
  );
  // Adjust for the timezone offset
  const countdownInterval = useRef(null); // UseRef to store the interval ID and clear it later

  const [cachedProperties, setCachedProperties] = useState(() => {
    const saved = sessionStorage.getItem('propertyList');
    return saved ? JSON.parse(saved) : [];
  });

  // handle the countdown
  useEffect(() => {
    if (pageNumber <= 30) {
      setPageNumber(pageNumber + 1);
    }
  }, [cachedProperties]);

  // Save scroll position on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (scrollContainerRef.current) {
        sessionStorage.setItem('propertyListScroll', scrollContainerRef.current.scrollTop);
      }
    };
    const node = scrollContainerRef.current;
    if (node) {
      node.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (node) {
        node.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);



  // Restore scroll position on mount and when properties are loaded
  useEffect(() => {
    const savedScroll = sessionStorage.getItem('propertyListScroll');
    if (scrollContainerRef.current && savedScroll) {
      setTimeout(() => {
        scrollContainerRef.current.scrollTop = parseInt(savedScroll, 10);
      }, 0);
    }
  }, [cachedProperties.length]);

  // Only fetch if not already cached for this page
  useEffect(() => {
    setError(null);
    // If we already have data for this page, do not fetch or show loader
    const saved = sessionStorage.getItem('propertyList');
    const parsed = saved ? JSON.parse(saved) : [];
    if ( pageNumber === 1) {
      setFetchLoading(false);
      setIsDataAvailable(true);

      return;
    }
    setFetchLoading(true);
    const fetchingPropertiesByPageNumber = async () => {
      console.log("page number",pageNumber)
      try {
        const states = selectedState.map((state) => state.value);
        const counties = selectedCounties.map((counties) => counties.value);
        const propertyType = selectedPropertyType.map((type) => type.value);
        const auctionStatus = selectedAuctionStatus.map(
          (status) => status.value
        );
        const propertyData = {
          pageNumber,
          pageSize: 50,
          sortBy: "",
          sortDirection: propertySortBy,
          isRemoteBidding: isRemoteBiddingEnable,
          state: states || [],
          county: counties || [],
          auctionStatus: auctionStatus || [],
          propertyType: propertyType || [],
          occupancyStatus: generalOccupancy,
          reportVacant: reportedVacancy ? "YN_Y" : "",
          startPriceRange: priceRange.min ? parseInt(priceRange.min) : 0,
          endPriceRange: priceRange.max ? parseInt(priceRange.max) : 0,
          beds: beds === "Any" ? 0 : beds,
          baths: baths === "Any" ? 0 : baths,
          sqFtStartRange: squareFootage.min ? parseInt(squareFootage.min) : 0,
          sqFtEndRange: squareFootage.max ? parseInt(squareFootage.max) : 0,
          lotSizeEndRange:
            lotSize.min && !isNaN(lotSize.min) ? parseInt(lotSize.min) : 0,
          lotSizeStartRange:
            lotSize.max && !isNaN(lotSize.max) ? parseInt(lotSize.max) : 0,
          yearBuiltStartRange: yearBuilt.min ? parseInt(yearBuilt.min) : 0,
          yearBuiltEndRange: yearBuilt.max ? parseInt(yearBuilt.max) : 0,
        };
        const response = await dispatch(
            fetchPropertiesByPageNumber(propertyData)
        ).unwrap();
        if (response.length === 0) {
          setIsDataAvailable(true);
        } else {
          setIsDataAvailable(true);
        }
        setCachedProperties(prev => {
          const all = [...prev, ...response];
          const unique = Array.from(new Map(all.map(item => [item.asset.auctionVendorPropId, item])).values());
          sessionStorage.setItem('propertyList', JSON.stringify(unique));
          return unique;
        });
      } catch (error) {
        setError(error);
      } finally {
        setFetchLoading(false);
      }
    };
    fetchingPropertiesByPageNumber();
  }, [pageNumber]);

  // Infinite scroll: only trigger fetch if not already cached
  const handleScroll = () => {
    const bottom =
      document.body.scrollHeight - 300 < window.scrollY + window.innerHeight;
    if (bottom && !fetchLoading && isDataAvailable) {
      setFetchLoading(true);
      setPageNumber((prevPageNumber) => prevPageNumber + 1);
    }
  };
  // Reset page number when isRemoteBiddingEnable changes
  useEffect(() => {
    setPageNumber(1);
  }, [isRemoteBiddingEnable, propertySortBy]);

  // Increment page number when fetchLoading changes
  useEffect(() => {
    if (fetchLoading) {
      setPageNumber(prev => prev + 1);
    }
  }, [fetchLoading]);

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }
  // To add event Listener to the handlescroll
  useEffect(() => {
    const debouncedScroll = debounce(handleScroll, 100);
    window.addEventListener("scroll", debouncedScroll);
    return () => {
      window.removeEventListener("scroll", debouncedScroll);
    };
  }, [fetchLoading, isDataAvailable]);


  const handleViewDetails = (property) => {
    const propertyId = property.asset.auctionVendorPropId;
    const remoteflag = property.asset.marketInfo.isRemoteBiddingEligible;
    navigate(`/auctionPage/${propertyId}`, { state: { remoteflag } });
  };

  function formatToDollar(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0, // No decimal places
      maximumFractionDigits: 0,
    }).format(amount);
  }

  const filterAuctionsWithDaysRemaining = () => {
    setPropertySortBy("DESC")
    setFilteredAuctions([]);
    setCachedProperties([])
    // const upcomingAuctions = cachedProperties?.filter((propertyItems) => {
    //   const startDate = moment.parseZone(
    //     `${propertyItems.asset.assetFclrInfo.currentSaleDate} ${propertyItems.asset.assetFclrInfo.currentSaleTime}`
    //   );
    //   const currentDate = moment();

    //   const daysRemaining = startDate.diff(currentDate, "days");

    //   if (daysRemaining >= 0) {
    //     return true;
    //   }
    //   return false;
    // });
    

    // // Update state with the filtered auctions
    // setFilteredAuctions(upcomingAuctions);
    setIsOpen(!isOpen);
  };

  const toggleFilteredAuctionList = () => {
    setPropertySortBy('')
    if (isOpen) {
      // If the list is open, clear the filtered auctions
      setFilteredAuctions([]);
      setCachedProperties([])
    }
    // Toggle the open state
    setIsOpen(!isOpen);
  };
  
  const handleAddFavoriteProperties = async (propertyId, index) => {
    setError(null);

    const requiredData = {
      investorId,
      propertyId,
      isRemoved: selectedIndex.includes(propertyId), // The toggled value for removal
    };

    try {
      // Dispatch action to add/remove from favorites
      if (selectedIndex.includes(propertyId)) {
        dispatch(removeSelectedId(propertyId));
      } else {
        dispatch(addSelectedId(propertyId));
      }
      await dispatch(addFavoriteProperty(requiredData));
      // Fetch the updated list of favorite properties
      // Optionally, you may want to handle the updated list in your UI here
    } catch (error) {
      console.log(error);
    }
  };

  const fetchfavproperties = async () => {
    const favproperties = await dispatch(
      getFavorityProperty(investorId)
    ).unwrap();
  };


  //need to update isRemoteBiddingEnable in url params
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const remoteBidding = urlParams.get("isRemoteBiddingEnable");

    if (!remoteBidding) {
      setIsRemoteBiddingEnable(true);
    } else {
      setIsRemoteBiddingEnable(remoteBidding === "true");
    }

  }, []); // Run only on mount

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("isRemoteBiddingEnable", isRemoteBiddingEnable.toString());
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
  }, [isRemoteBiddingEnable]);

  return (
    <>
      <div className='flex justify-start items-center'>
      </div>
      <div className="productDetailContainer">
        <Helmet>
          <title>{`xBid | Search`}</title>
          <meta
            name="description"
            content={`Browse ${cachedProperties?.length || 0
              } auction properties. Filter by location, price, and property features. Live and upcoming auctions available.`}
          />
        </Helmet>
        {/* Sub Navbar */}
        <PropertiesFilterHeader
          setPageNumber={setPageNumber}
          fetchfavproperties={fetchfavproperties}
          setIsFilterOpen={setIsFilterOpen}
          isFilterOpen={isFilterOpen}
          setLoading={setLoading}
          setSelectedPropertyType={setSelectedPropertyType}
          selectedState={selectedState}
          selectedAuctionStatus={selectedAuctionStatus}
          setSelectedAuctionStatus={setSelectedAuctionStatus}
          selectedPropertyType={selectedPropertyType}
          setSelectedCounties={setSelectedCounties}
          setSelectedState={setSelectedState}
          setIsRemoteBiddingEnable={setIsRemoteBiddingEnable}
          isRemoteBiddingEnable={isRemoteBiddingEnable}
          selectedCounties={selectedCounties}
          generalOccupancy={generalOccupancy}
          baths={baths}
          setBaths={setBaths}
          setReportedVacancy={setReportedVacancy}
          setGeneralOccupancy={setGeneralOccupancy}
          reportedVacancy={reportedVacancy}
          setPriceRange={setPriceRange}
          priceRange={priceRange}
          beds={beds}
          setBeds={setBeds}
          lotSize={lotSize}
          setLotSize={setLotSize}
          squareFootage={squareFootage}
          setSquareFootage={setSquareFootage}
          yearBuilt={yearBuilt}
          setYearBuilt={setYearBuilt}
          headertitle="Look for properties in"
          isPropertyTab
          setCachedProperties={setCachedProperties}
          setPropertySortBy={setPropertySortBy}
          propertySortBy={propertySortBy}
        />
        {isMobile && (
          <div className=" md:mx-4 mx-0 md:mb-0 mb-2 flex justify-between items-center">
            <div className=" flex items-center p-2 gap-1">
              <span className="font-normal"> Auction Starting Soon </span>{" "}
              {isOpen ? (
                <GoChevronUp
                  aria-label="GoChevronUp-1111"
                  onClick={toggleFilteredAuctionList}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <GoChevronDown
                  aria-label="GoChevronDown-1111"
                  style={{ cursor: "pointer" }}
                  onClick={filterAuctionsWithDaysRemaining}
                />
              )}
            </div>
            <div
              className="flex gap-x-1"
              onClick={() => setIsFilterOpen((prev) => !prev)}
            >
              <img src={filterIcon} alt="" />{" "}
              <p className="underline"> Filters</p>
            </div>
          </div>
        )}
        {/* Property list */}
        <div ref={scrollContainerRef} className=" bg-white md:p-4 p-0 md:pb-0 pb-3">
          <div className=" flex justify-between mb-4">
            <h2 className="text-lg font-semibold ml-2" role="heading" aria-level="1">

              {cachedProperties.length>0&&`Showing ${cachedProperties?.length} Auction Properties`}
            </h2>
            {!isMobile && (
              <div className="flex items-center gap-1">
                <p className="text-base font-semibold">Sort By: </p>
                <span className="font-normal">
                  {" "}
                  Auction Starting Soon{" "}
                </span>{" "}
                {isOpen ? (
                  <GoChevronUp
                    aria-label="GoChevronUp-1111"
                    onClick={toggleFilteredAuctionList}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <GoChevronDown
                    aria-label="GoChevronDown-1111"
                    style={{ cursor: "pointer" }}
                    onClick={filterAuctionsWithDaysRemaining}
                  />
                )}
              </div>
            )}
          </div>
          <div className="space-y-4">
            {isOpen && filteredAuctions.length > 0 ? (
              // Render the filtered auctions list when there are items
              <div>
                {filteredAuctions.map((items, index) => {
                  return (
                    <div
                      key={index}
                      className="bg-white flex p-2 w-full mb-3 shadow-sm shadow-slate-400/50"
                    >
                      {/* Auction Info Section */}
                      <Grid
                        container
                        sx={{ width: "100%" }}
                        spacing={{ xs: 1, sm: 2 }}
                      >
                        <Grid
                          item
                          minWidth={{
                            xs: "150px",
                            sm: "200px", // Set a minimum width to ensure consistency
                          }}
                          maxWidth={{
                            xs: "33%",
                            sm: "25%",
                            md: "20%",
                            lg: "15%",
                          }}
                          style={{
                            height: "auto", // Adjust this if you need a fixed height
                            position: "relative", // Add this to position the heart icon inside the image container
                          }}
                        >
                          <div
                            style={{
                              position: "relative",
                              width: 200,
                              height: 140,
                            }}
                          >
                            <img
                              src={items?.imageUrl}
                              alt="Property"
                              className="w-full h-full object-fill rounded-none" // Use object-cover to maintain aspect ratio
                            />
                            <IconButton
                              onClick={() =>
                                handleAddFavoriteProperties(
                                  items.asset.auctionVendorPropId,
                                  index
                                )
                              }
                              style={{
                                position: "absolute",
                                top: "3px", // Adjust to control distance from the top
                                left: "3px", // Adjust to control distance from the left
                                zIndex: 1, // Ensure the icon stays on top of the image
                                cursor: "pointer",
                              }}
                              id={index}
                              aria-label={
                                !selectedIndex.includes(items.asset.auctionVendorPropId)
                                  ? "Add to favorites"
                                  : "Remove from favorites"
                              }
                            >
                              {/* Conditional rendering of the icon */}
                              {!selectedIndex.includes(
                                items.asset.auctionVendorPropId
                              ) ? (
                                <svg
                                  stroke="#ffffff"
                                  aria-label="fav-sv-1113"
                                  fill="#ffffff"
                                  stroke-width="0"
                                  viewBox="0 0 1024 1024"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
                                </svg>
                              ) : (
                                <svg
                                  stroke="#ffffff"
                                  aria-label="fav-sv-1114"
                                  fill="#ffffff"
                                  stroke-width="0"
                                  viewBox="0 0 1024 1024"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z"></path>
                                </svg>
                              )}
                            </IconButton>
                          </div>
                        </Grid>
                        <Grid size={{ xs: 7, sm: "auto" }}>
                          <p className="text-lg sm:text-xl">
                            <span className="text-[20px] font-semibold leading-[30px]">
                              $
                              {items?.asset?.openingBidHistoryInfo
                                ?.openingBidAmount === null || items?.asset?.openingBidHistoryInfo
                                  ?.openingBidAmount === 0 || items?.asset?.openingBidHistoryInfo
                                    ?.openingBidAmount === 0.00
                                ? (items?.asset?.auctionReserveInfo?.reserveValue > 0 ? formatToDollar(items?.asset?.auctionReserveInfo?.reserveValue) : 0)

                                : formatToDollar(
                                  items?.asset?.openingBidHistoryInfo
                                    ?.openingBidAmount
                                )}
                            </span>
                            <span className="text-[14px] font-normal leading-[21px]">
                              {" "}
                              Est. Opening Bid
                            </span>
                          </p>
                          <p className="mt-1 sm:mt-2  sm:font-light text-[10px] sm:text-base">
                            {items?.asset?.marketInfo
                              ?.isRemoteBiddingEligible === true
                              ? "Foreclosure Trustee - Remote bid enabled"
                              : "Foreclosure Trustee"}
                          </p>
                          <p className="mt-1 sm:mt-2 text-sm sm:text-base font-medium text-gray-700">
                            {items?.asset?.address1} {items?.asset?.city} ,
                            {items?.asset?.state} {items?.asset?.zipCode}
                          </p>
                          {!isMobile && (
                            <>
                              <div className="flex items-center space-x-2 mt-2">
                                {items?.asset?.marketInfo?.beds && (
                                  <div className="flex items-center space-x-1">
                                    {/* <HotelIcon className="text-gray-600" /> */}
                                    <img src={Bed} alt="bed" />
                                    <span>
                                      {items?.asset?.marketInfo?.beds} Beds
                                    </span>
                                  </div>
                                )}
                                {items?.asset?.marketInfo?.fullBaths && (
                                  <div className="flex items-center space-x-1">
                                    {/* <BathtubOutlinedIcon className="text-gray-600" /> */}
                                    <img src={Bath} alt="bed" />
                                    <span>
                                      {items?.asset?.marketInfo?.fullBaths}{" "}
                                      Baths
                                    </span>
                                  </div>
                                )}
                                {items?.asset?.marketInfo?.sqFt && (
                                  <div className="flex items-center space-x-1">
                                    {/* <CottageOutlinedIcon className="text-gray-600" /> */}
                                    <img src={Sqft} alt="bed" />
                                    <span>
                                      {formatToDollar(
                                        items?.asset?.marketInfo?.sqFt
                                      )}{" "}
                                      Sq. Ft.
                                    </span>
                                  </div>
                                )}
                              </div>
                              <div className="w-3/5 mt-2">
                                <>
                                  {moment
                                    .parseZone(
                                      `${items?.asset?.assetFclrInfo?.currentSaleDate} ${items?.asset?.assetFclrInfo?.currentSaleTime}`
                                    )
                                    .format("MMM D, hh:mm A")}
                                </>
                                {/*  )} */}
                              </div>
                            </>
                          )}
                        </Grid>
                        <Grid
                          size={{ xs: 12, sm: "auto" }}
                          display={"flex"}
                          ml={{ sm: "auto" }}
                          justifyContent={"space-between"}
                          alignItems={{ sm: "flex-end" }}
                          rowGap={{ xs: 1 }}
                          flexDirection={"column"}
                        >
                          <div className="flex space-x-3">
                            {items?.cashOnlyTag == "Cash Only" ? <CashIcon /> : ""}
                            {items?.asset?.marketInfo?.reportedVacant == "YN_Y" ? <ReportedIcon /> : ""}
                          </div>
                          {isMobile && (
                            <>
                              <div className="flex items-center space-x-2 mt-2">
                                {items?.asset?.marketInfo?.beds && (
                                  <div className="flex items-center space-x-1">
                                    {/* <HotelIcon className="text-gray-600" /> */}
                                    <img src={Bed} alt="bed" />
                                    <span>
                                      {items?.asset?.marketInfo?.beds} Beds
                                    </span>
                                  </div>
                                )}
                                {items?.asset?.marketInfo?.fullBaths && (
                                  <div className="flex items-center space-x-1">
                                    {/* <BathtubOutlinedIcon className="text-gray-600" /> */}
                                    <img src={Bath} alt="bed" />
                                    <span>
                                      {items?.asset?.marketInfo?.fullBaths}{" "}
                                      Baths
                                    </span>
                                  </div>
                                )}
                                {items?.asset?.marketInfo?.sqFt && (
                                  <div className="flex items-center space-x-1">
                                    {/* <CottageOutlinedIcon className="text-gray-600" /> */}
                                    <img src={Sqft} alt="bed" />
                                    <span>
                                      {formatToDollar(
                                        items?.asset?.marketInfo?.sqFt
                                      )}{" "}
                                      Sq. Ft.
                                    </span>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                          <div className="flex justify-between">
                            {isMobile && (
                              <div>
                                <>
                                  {moment
                                    .parseZone(
                                      `${items?.asset?.assetFclrInfo?.currentSaleDate} ${items?.asset?.assetFclrInfo?.currentSaleTime}`
                                    )
                                    .format("MMM D, hh:mm A")}
                                </>
                                {/* )} */}
                              </div>
                            )}
                            <button
                              className=" text-white rounded-lg bg-[#FF5C39] px-[16px] py-[10px]"
                              onClick={() => handleViewDetails(items)}
                            >
                              View Details
                            </button>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  );
                })}
              </div>
            ) : (
              // Render all properties if no filtered auctions or isOpen is false
              <div>
                {cachedProperties &&
                  cachedProperties?.map((property, index) => {
                    return (
                      <Grid
                        key={index}
                        container
                        className="bg-white p-2 flex w-full mb-3 "
                        sx={{ width: "100%" }}
                        spacing={{ xs: 1, sm: 2 }}
                        style={{ boxShadow: "0px 0px 3px 2px rgba(0,0,0,.1)" }}
                      >
                        <Grid
                          item
                          size={{ xs: 4, sm: 3, md: 1.7 }}
                          style={{
                            height: "auto", // Adjust this if you need a fixed height
                            position: "relative", // Add this to position the heart icon inside the image container
                          }}
                        >
                          <div
                            className={isMdOrLarger ? "w-[100%]" : ""}
                            style={{
                              position: "relative",
                              // width: 200,
                              padding: "5px",
                              height: 140,

                            }}
                          >
                            <img
                              src={property?.imageUrl}
                              alt="Property"
                              className=" w-full h-full object-cover rounded-none" // Use object-cover to maintain aspect ratio
                            />
                            <IconButton
                              id={index}
                              onClick={() =>
                                handleAddFavoriteProperties(
                                  property?.asset?.auctionVendorPropId,
                                  index
                                )
                              }
                              style={{
                                position: "absolute",
                                top: "3px", // Adjust to control distance from the top
                                left: "3px", // Adjust to control distance from the left
                                zIndex: 1, // Ensure the icon stays on top of the image
                                cursor: "pointer",
                              }}
                              aria-label={
                                !selectedIndex.includes(property?.asset?.auctionVendorPropId)
                                  ? "Add to favorites"
                                  : "Remove from favorites"
                              }
                            >
                              {/* Conditional rendering of the icon */}
                              {!selectedIndex.includes(property?.asset?.auctionVendorPropId) ? (
                                <svg
                                  aria-label="fav-sv-1115"
                                  stroke="#ffffff"
                                  fill="#ffffff"
                                  stroke-width="0"
                                  viewBox="0 0 1024 1024"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
                                </svg>
                              ) : (
                                <svg
                                  aria-label="fav-sv-1116"
                                  stroke="#ffffff"
                                  fill="#ffffff"
                                  stroke-width="0"
                                  viewBox="0 0 1024 1024"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z"></path>
                                </svg>
                              )}
                            </IconButton>
                          </div>
                        </Grid>

                        <Grid size={{ xs: 7, sm: "auto" }}>
                          <p className="text-lg sm:text-xl">
                            <span className="text-[20px] font-semibold leading-[30px]">
                              $
                              {property?.asset?.openingBidHistoryInfo
                                ?.openingBidAmount === null || property?.asset?.openingBidHistoryInfo
                                  ?.openingBidAmount === 0 || property?.asset?.openingBidHistoryInfo
                                    ?.openingBidAmount === 0.00
                                  ? (property?.asset?.auctionReserveInfo?.reserveValue > 0 ? formatToDollar(property?.asset?.auctionReserveInfo?.reserveValue) : 0)
                                  : formatToDollar(
                                    property?.asset?.openingBidHistoryInfo
                                      ?.openingBidAmount
                                  )}
                            </span>
                            <span className="text-[14px] font-normal leading-[21px]">
                              {" "}
                              Est. Opening Bid
                            </span>
                          </p>
                          <p className="mt-1 sm:mt-2  sm:font-light text-[10px] sm:text-base">
                            {property?.asset?.marketInfo
                              ?.isRemoteBiddingEligible === true
                              ? "Foreclosure Trustee - Remote bid enabled"
                              : "Foreclosure Trustee"}
                          </p>
                          <p className="mt-1 sm:mt-2 text-sm sm:text-base font-medium text-gray-700">
                            {property?.asset?.address1} {property?.asset?.city}{" "}
                            , {property?.asset?.state}{" "}
                            {property?.asset?.zipCode}
                          </p>
                          {!isMobile && (
                            <>
                              <div className="flex items-center space-x-2 mt-2">
                                {property?.asset?.marketInfo?.beds && (
                                  <div className="flex items-center space-x-1">
                                    {/* <HotelIcon className="text-gray-600" /> */}
                                    <img src={Bed} alt="bed" />
                                    <span>
                                      {property?.asset?.marketInfo?.beds} Beds
                                    </span>
                                  </div>
                                )}
                                {property?.asset?.marketInfo?.fullBaths && (
                                  <div className="flex items-center space-x-1">
                                    {/* <BathtubOutlinedIcon className="text-gray-600" /> */}
                                    <img src={Bath} alt="bed" />
                                    <span>
                                      {property?.asset?.marketInfo?.fullBaths}{" "}
                                      Baths
                                    </span>
                                  </div>
                                )}
                                {property?.asset?.marketInfo?.sqFt && (
                                  <div className="flex items-center space-x-1">
                                    {/* <CottageOutlinedIcon className="text-gray-600" /> */}
                                    <img src={Sqft} alt="bed" />
                                    <span>
                                      {formatToDollar(
                                        property?.asset?.marketInfo?.sqFt
                                      )}{" "}
                                      Sq. Ft.
                                    </span>
                                  </div>
                                )}
                              </div>
                              <div className="w-3/5 mt-2">
                                <>
                                  {moment
                                    .parseZone(
                                      `${property?.asset?.assetFclrInfo?.currentSaleDate} ${property?.asset?.assetFclrInfo?.currentSaleTime}`
                                    )
                                    .format("MMM D, hh:mm A")}
                                </>
                                {/* )} */}
                              </div>
                            </>
                          )}
                        </Grid>
                        <Grid
                          size={{ xs: 12, sm: "auto" }}
                          display={"flex"}
                          ml={{ sm: "auto" }}
                          justifyContent={"space-between"}
                          alignItems={{ sm: "flex-end" }}
                          rowGap={{ xs: 1 }}
                          flexDirection={"column"}
                        >
                          <div className="flex space-x-3">
                            {property?.cashOnlyTag == "Cash Only" ? <CashIcon /> : ""}
                            {property?.asset?.marketInfo?.reportedVacant == "YN_Y" ? <ReportedIcon /> : ""}
                          </div>
                          {isMobile && (
                            <>
                              {(property?.asset?.marketInfo?.beds ||
                                property?.asset?.marketInfo?.fullBaths ||
                                property?.asset?.marketInfo?.fullBaths) && (
                                  <div className="flex items-center space-x-2 mt-2">
                                    {property?.asset?.marketInfo?.beds && (
                                      <div className="flex items-center space-x-1">
                                        {/* <HotelIcon className="text-gray-600" /> */}
                                        <img src={Bed} alt="bed" />
                                        <span>
                                          {property?.asset?.marketInfo?.beds} Beds
                                        </span>
                                      </div>
                                    )}
                                    {property?.asset?.marketInfo?.fullBaths && (
                                      <div className="flex items-center space-x-1">
                                        {/* <BathtubOutlinedIcon className="text-gray-600" /> */}
                                        <img src={Bath} alt="bed" />
                                        <span>
                                          {property?.asset?.marketInfo?.fullBaths}{" "}
                                          Baths
                                        </span>
                                      </div>
                                    )}
                                    {property?.asset?.marketInfo?.sqFt && (
                                      <div className="flex items-center space-x-1">
                                        {/* <CottageOutlinedIcon className="text-gray-600" /> */}
                                        <img src={Sqft} alt="bed" />
                                        <span>
                                          {formatToDollar(
                                            property?.asset?.marketInfo?.sqFt
                                          )}{" "}
                                          Sq. Ft.
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                )}
                            </>
                          )}
                          <div className="flex justify-between items-center">
                            {isMobile && (
                              <div>

                                <>
                                  {moment
                                    .parseZone(
                                      `${property?.asset?.assetFclrInfo?.currentSaleDate} ${property?.asset?.assetFclrInfo?.currentSaleTime}`
                                    )
                                    .format("MMM D, hh:mm A")}
                                </>
                                {/* )} */}
                              </div>
                            )}
                            <button
                              className=" text-white rounded-lg bg-[#FF5C39] px-[16px] py-[10px]"
                              onClick={() => handleViewDetails(property)}
                            >
                              View Details
                            </button>
                          </div>
                        </Grid>
                      </Grid>
                    );
                  })}
                {/* {isDataAvailable && fetchLoading && (
                  <div
                    className={`w-full h-[10vh] flex items-center justify-center`}
                  >
                    <CircularProgress sx={{ color: "#faaf19" }} />
                  </div>
                )} */}
                {!isDataAvailable && (
                  <p className="text-center py-2 text-lg font-medium">
                    {cachedProperties.length > 0
                      ? "No more properties available..."
                      : "No properties available"}
                  </p>
                )}
              </div>
            )}
          </div>
          <div className="flex justify-center items-center">
            {loading && (
              <p className="text-lg font-medium text-[#FF5C39]">Loading...</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default List;
